namespace SPA
{
export namespace Managers
{
export namespace Session
{

	export class LoginScreen
	{

		private m_Form:		ui.Form.Form;
		private m_Modal:	ui.dialog.Modal|null;

		public constructor()
		{
			this.m_Modal	= null;
			this.m_Form		= new ui.Form.Form(
				{
					action: '/account/login',
					method: 'POST',
					submit: ( method: ui.Form.FormMethod, url: string, parameter: ui.Form.IFormParameter ): void =>
					{
						//@ts-ignore
						app.getAuthenticationManager().login2( parameter.username, parameter.password );
					},
					static: false,
					notSwitchable: true
				}
			);
		}

		public show(): void
		{

		}

		public hide(): void
		{
			this.m_Form.reset();
		}

	}

}
}
}
